const WIDTH_SP = 768;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.classList.remove('preload');

    // 各初期化関数の呼び出し
    initHeader();
    initRetina();
    initImage();
    initSmoothScroll();
    initIsOn();
    initMenu();
    doFade();
    moreBtn();
    initFixedBanner();
    initSwiper();
    initLazyVideo();
    initInfluenceUgc();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      //xxxxxxxx();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();

// ヘッダーの固定処理
const initHeader = () => {
  const header = document.getElementById('header');
  const target = document.querySelector('.js-menu-disp');

  if (!header || !target) return;

  let wasFixed = false; // flag

  window.addEventListener('scroll', () => {
    const targetTop = target.getBoundingClientRect().top;

    if (targetTop < 0 && !wasFixed) {
      // fixedクラスを追加
      header.classList.add('fixed');
      header.classList.remove('sliding-up');
      //nextElem.style.marginTop = headerH + "px";
      wasFixed = true;
    } else if (targetTop >= 0 && wasFixed) {
      // fixedクラスを削除し、sliding-upクラスを一時的に追加
      header.classList.add('sliding-up');
      wasFixed = false;

      // アニメーション終了後に sliding-up クラスを削除
      setTimeout(() => {
        header.classList.remove('sliding-up');
        header.classList.remove('fixed');
        //nextElem.style.marginTop = "";
      }, 500);
    }
  });
};

// Retina対応
const initRetina = () => {
  if (window.devicePixelRatio >= 2) {
    document.querySelectorAll('.retina').forEach(img => {
      const retinaSrc = img.getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
      img.setAttribute('srcset', `${retinaSrc} 2x`);
    });
  }
};

// WebP対応
const initImage = () => {
  const isSupportsWebP = callback => {
    const webP = new Image();
    webP.onload = webP.onerror = () => callback(webP.height === 2);
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
  };

  isSupportsWebP(isSupported => {
    if (isSupported) {
      document.querySelectorAll('img.webp').forEach(img => {
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc) {
          const webpSrc = dataSrc.replace(/\.(jpg|jpeg|png)$/i, '.webp');
          img.setAttribute('data-src', webpSrc);
          
          if( !img.classList.contains("lazyload")) {
            img.setAttribute('src', webpSrc);
          }
        }

        const parentPicture = img.closest('picture');
        if (parentPicture) {
          const source = parentPicture.querySelector('source');
          if (source?.getAttribute('data-srcset')) {
            const webpSrcSet = source.getAttribute('data-srcset').replace(/\.(jpg|jpeg|png)$/i, '.webp');
            source.setAttribute('data-srcset', webpSrcSet);
            source.setAttribute('srcset', webpSrcSet);
          }
        }
      });

      document.querySelectorAll('video.webp[poster]').forEach(video => {
        const poster = video.getAttribute('poster');
        if (poster) {
          const webpPoster = poster.replace(/\.(jpg|jpeg|png)$/i, '.webp');
          video.setAttribute('poster', webpPoster);
        }
      });
    }
  });
};

// メニュー初期化
const initMenu = () => {
  const iconMenu = document.getElementById('icon-menu');
  const headerMenu = document.getElementById('header-menu');

  iconMenu?.addEventListener('click', () => {
    iconMenu.classList.toggle('checked');
    headerMenu.classList.toggle('active');
  });

  document.querySelectorAll('.header-menu__item a').forEach(link => {
    link.addEventListener('click', () => {
      iconMenu.classList.remove('checked');
      headerMenu.classList.remove('active');
    });
  });
};

// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const gap = document.getElementById('header')?.clientHeight || 0 + 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// アコーディオン開閉
const moreBtn = () => {
  const moreBtn = Array.from(document.querySelectorAll('.js-accordion-btn'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function() {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;
      
      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });
}

// fixedバナーの表示制御
const initFixedBanner = () => {
  const fixedBanner = document.querySelector("#fixed-banner");
  const targetSections = document.querySelectorAll(".mv, .cta");

  if (!fixedBanner || targetSections.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      let isIntersecting = false;

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isIntersecting = true;
        }
      });

      if (isIntersecting) {
        fixedBanner.classList.remove("active");
      } else {
        fixedBanner.classList.add("active");
      }
    },
    { threshold: 0.3 } // 10%以上表示されたら判定
  );

  targetSections.forEach((section) => observer.observe(section));
};

// スライダー
const initSwiper = () => {
  // すべてのスライダーを取得
  const sliderContainers = document.querySelectorAll(".cta-images");

  sliderContainers.forEach((container, index) => {
    const sliderThumbnailEl = container.querySelector(".cta-slider-thumbnail");
    const sliderMainEl = container.querySelector(".cta-slider");

    if (!sliderThumbnailEl || !sliderMainEl) return;

    // サムネイルスライダーの初期化
    const sliderThumbnail = new Swiper(sliderThumbnailEl, {
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 0,
      watchSlidesProgress: true
    });

    // メインスライダーの初期化
    const slider = new Swiper(sliderMainEl, {
      loop: true,
      slidesPerView: 1,
      speed: 300,
      thumbs: {
        swiper: sliderThumbnail, // サムネイルスライダーを連携
      },
    });
  });

  /* 
  const ugcSlide = new Swiper("#ugc-slide", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 8,
    speed: 8000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loopAdditionalSlides: 5,
    lazy: true,
    freeMode: true,
    freeModeMomentum: false,
  }); */


  /* const point3Scroll1 = new Swiper(".point3__scroll1", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    speed: 6000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loopAdditionalSlides: 5,
    freeMode: true,
    freeModeMomentum: false,
  });

  const point3Scroll2 = new Swiper(".point3__scroll2", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    speed: 6000, // 一定の速度でスライド
    allowTouchMove: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      reverseDirection: true, // 逆方向にスライド
    },
    loopAdditionalSlides: 5, // ループ時のカクつきを軽減
    freeMode: false, // ✅ freeMode を true に変更
    freeModeMomentum: false, // ✅ 慣性スクロールを無効化
  });

  // ✅ ページ読み込み直後に autoplay を強制的に開始
  window.addEventListener("load", () => {
    setTimeout(() => {
      point3Scroll2.autoplay.stop();
      point3Scroll2.autoplay.start();
    }, 100);
  });

  // ✅ タブのアクティブ状態が変わったときにスライドを再開
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      point3Scroll2.autoplay.stop();
      point3Scroll2.autoplay.start();
    }
  }); */
};

const initLazyVideo = () => {
  const lazyVideos = document.querySelectorAll("video.lazy-video");
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        if (video.dataset.src) {
          video.src = video.dataset.src;
          video.removeAttribute("data-src"); // 不要になったら削除
        }
        observer.unobserve(video); // 監視を停止
      }
    });
  });

  //lazyVideos.forEach(video => observer.observe(video));

  // 初期の `video.lazy-video` を監視
  document.querySelectorAll("video.lazy-video").forEach(video => observer.observe(video));

  // **動画リストが増えたら監視するための `MutationObserver` を追加**
  const slideContainer = document.querySelector("#ugc-slide ul");
  if (!slideContainer) return;

  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          const videos = node.querySelectorAll?.("video.lazy-video") || [];
          videos.forEach(video => observer.observe(video));
        }
      });
    });
  });

  mutationObserver.observe(slideContainer, { childList: true, subtree: true });

}


// Add new function initInfluenceUgc inside initLazyVideo
const initInfluenceUgc = () => {
  const influenceUgcItems = document.querySelectorAll(".influence-ugc li");
  const rowScrolls = document.querySelectorAll(".row-scroll");

  influenceUgcItems.forEach((item) => {
    const pauseAnimation = () => {
      rowScrolls.forEach((scroll) => {
        scroll.style.animationPlayState = "paused";
      });
    };

    const resumeAnimation = () => {
      rowScrolls.forEach((scroll) => {
        scroll.style.animationPlayState = "running";
      });
    };

    //item.addEventListener("mousedown", pauseAnimation);
    //item.addEventListener("mouseup", resumeAnimation);
    item.addEventListener("touchstart", pauseAnimation);
    item.addEventListener("touchend", resumeAnimation);
    item.addEventListener("mouseenter", pauseAnimation);
    item.addEventListener("mouseleave", resumeAnimation);
  });
};
